<template>
  <Section id="step-four">
    <Counter>4</Counter>
    <Heading>Install Karma bot to Slack</Heading>
    <Description>
      Manually install Karma bot app and invite its bot to each relevant channel. Karma bot is a chat
bot for better people culture and performance tracking. The bot encourages recognition and
appreciation in teams.
    </Description>
    <Action>
      <a href="https://app.karmabot.chat/install?source=discord2slack" class="btn btn--primary" target="_blank">Install Karma bot</a>
    </Action>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'
  import Counter from './UI/Counter'
  import Action from './UI/Action'

  export default {
    components: {
      Section,
      Heading,
      Description,
      Counter,
      Action
    }
  }
</script>

<style lang="scss" scoped>
  
</style>
